const dragScroll = {
  install(Vue, options) {
    Vue.directive("dragScroll", function(el) {
      el.onmousedown = function(ev) {
        var speedX = 0; //要求的速度
        var lastX = 0; //最后一次的距离
        const disX = ev.clientX - el.offsetLeft;
        const originalScrollLeft = el.scrollLeft;
        const originalScrollBehavior = el.style["scroll-behavior"];
        const originalPointerEvents = el.style["pointer-events"];
        el.style["scroll-behavior"] = "auto";
        // 鼠标移动事件是监听的整个document，这样可以使鼠标能够在元素外部移动的时候也能实现拖动
        document.onmousemove = function(ev) {
          ev.preventDefault();
          const distanceX = ev.clientX - el.offsetLeft - disX;
          el.scrollTo(originalScrollLeft - distanceX, 0);
          speedX = el.scrollLeft - lastX;
          lastX = el.scrollLeft;

          // 由于我们的图片本身有点击效果，所以需要在鼠标拖动的时候将点击事件屏蔽掉
          el.style["pointer-events"] = "none";
        };
        document.onmouseup = function(ev) {
          document.onmousemove = null;
          document.onmouseup = null;
          el.style["scroll-behavior"] = originalScrollBehavior;
          el.style["pointer-events"] = originalPointerEvents;

          clearInterval(el.timer);
          el.timer = setInterval(function() {
            speedX *= 0.95; //摩擦
            el.scrollTo(el.scrollLeft + speedX, 0);
            if (Math.abs(speedX) < 1) speedX = 0;
            if (speedX == 0) {
              clearInterval(el.timer);
            }
          }, 30);
        };
      };
    });
  }
};
export default dragScroll;



// WEBPACK FOOTER //
// ./src/components/common/dragScroll.js